import React, { useEffect, useState } from 'react';
import { PromoSection } from '@sfly/cart-shared-library';
import type { PromoAdapter, UserInfo } from '@sfly/cart-shared-library';
import type { PromoSectionConfig } from './types.js';
import { fetchUserInfo, getEnvConfig } from './utils/commonUtil.js';

const envConfig = getEnvConfig();

const cartConfig = {
  discoveryConfig: {
    cartURL: envConfig.cartapi,
    accounts: envConfig.accounts,
    retailUrl: envConfig.retail,
    create: envConfig.create,
    commerce: envConfig.commerce,
    catalogproduct: envConfig.catalogproduct,
    shopping: envConfig.shopping,
    photosUrl: envConfig.photosbaseurl,
    accountsFEUrl: envConfig.accountsfe,
  },
};

interface PromoAppProps {
  config: PromoSectionConfig;
}

export const PromoApp: React.FC<PromoAppProps> = ({ config }) => {
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);

  useEffect(() => {
    fetchUserInfo()
      .then((info) =>
        setUserInfo({ ...info, xApiKey: envConfig.cartApiKey } as UserInfo),
      )
      .catch(() => {});
  }, []);

  const adapter: PromoAdapter = {
    cartInfo: config.cartInfo,
    promotionsDesc: config.promotionsDesc,
    couponErrorMessage: config.couponErrorMessage,
    accountInfo: config.accountInfo,
    variant: config.variant,
    orderUpdateCallback: config.orderUpdateCallback,
    onOrderUpdateFailure: config.onOrderUpdateFailure,
    updatePromoDescCallback: config.updatePromoDescCallback,
  };

  if (!userInfo) return null;

  return (
    <div className="sfly-cart-root">
      <PromoSection
        userInfo={userInfo}
        cartConfig={cartConfig}
        adapter={adapter}
      />
    </div>
  );
};
